import { FormattedMessage } from 'react-intl'
import { getRouteApi, Link } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'

import { useAuth } from '@/hooks/use-auth'

import { HeaderNavDropdown } from './header-nav-dropdown'
import { HeaderNavigationSites } from './header-navigation-sites'

const routeApi = getRouteApi('/_layout/_private')
export const HeaderNavigation = () => {
  const { user, isAuthorized } = useAuth()
  const navigate = routeApi.useNavigate()
  const isSmAndLower = useMediaQuery('down', 800)
  if (!user || !isAuthorized || isSmAndLower) {
    return null
  }

  const rewardsoptions = [
    {
      label: <FormattedMessage id="header.navigation.rewards.summary" />,
      onClick: () => {
        navigate({ to: '/app/rewards', viewTransition: true }).catch(console.error)
      },
    },
    {
      label: <FormattedMessage id="header.navigation.rewards.redeemEdge" />,
      onClick: () => {
        navigate({ to: '/app/rewards/edge', viewTransition: true }).catch(console.error)
      },
    },
    {
      label: <FormattedMessage id="header.navigation.rewards.edgeHistory" />,
      onClick: () => {
        navigate({ to: '/app/rewards/edge-history', viewTransition: true }).catch(console.error)
      },
    },
  ]

  return (
    <nav className="flex w-full items-center justify-center gap-8 md:w-auto md:gap-0">
      <HeaderNavDropdown
        label={<FormattedMessage id="common.labels.myRewards" />}
        options={rewardsoptions}
        onLabelClick={() => {
          navigate({ to: '/app/rewards' }).catch(console.error)
        }}
      />
      <HeaderNavigationSites />
      <Button
        as={Link}
        className="transition-colors duration-300 hover:bg-transparent hover:text-primary-main"
        href="/faq"
        size="small"
        variant="text"
      >
        <FormattedMessage id="common.controls.faq" />
      </Button>
      <Button
        as={Link}
        className="transition-colors duration-300 hover:bg-transparent hover:text-primary-main"
        href="/support"
        size="small"
        variant="text"
      >
        <FormattedMessage id="common.controls.support" />
      </Button>
    </nav>
  )
}
